import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../../components/reusable/Button/Button';
import AutomatedRuleTable from '../../../components/reusable/Tables/AutomatedRuleTable';
import { SETTING_AUTOMATED_RULES_PATH } from '../../../contants';
import { setRuleManagerState } from '../../../features/userSettings/userSettingsSlice';
import css from './../UserSettings.module.css';
import AutomatedRuleManager from './components/AutomatedRuleManager';
import style from './styles.module.css';

const AutomatedRules = () => {
  const [mode, setMode] = useState(null);

  const { ruleManagerState } = useSelector(state => state.userSettings);
  const dispatch = useDispatch();

  const { id } = useParams();
  const navigate = useNavigate();

  const handleClickAddNewRule = () => {
    setMode('create');
    dispatch(setRuleManagerState(true));
  };

  useEffect(() => {
    const idRuleIsValid = id && !isNaN(id);

    if (idRuleIsValid) {
      dispatch(setRuleManagerState(true));
      setMode('edit');
    } else {
      dispatch(setRuleManagerState(false));
      navigate(SETTING_AUTOMATED_RULES_PATH);
    }
  }, [id]);

  return (
    <div className={css.main}>
      <div className={css.wrapper}>
        {ruleManagerState ? (
          <AutomatedRuleManager mode={mode} setMode={setMode}/>
        ) : (
          <>
            <Button
              styled="addClient"
              title="+ Add New Rules"
              onClick={handleClickAddNewRule}
            />

            <div className={style.table}>
              <AutomatedRuleTable />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AutomatedRules;
